import {useEffect, useRef, useState} from 'react';
import {jwtDecode} from 'jwt-decode';
import {acknowledgeJobImportant, getJobDetails} from '../service/JobService';
import {importantRevision, needsAcknowledgement} from '../service/jobScheduling';

function isAdmin() {
    try { return jwtDecode(localStorage.getItem('cosToken') || '').optinestUser?.optinestApiUser?.role === 'ADMIN'; }
    catch (_) { return false; }
}

export default function ImportantAcknowledgement({job, onUpdated, disabled = false}) {
    const updateRef = useRef(onUpdated);
    useEffect(() => { updateRef.current = onUpdated; }, [onUpdated]);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');
    if (!onUpdated || !needsAcknowledgement(job) || !isAdmin()) return null;
    async function acknowledge(event) {
        event.preventDefault(); event.stopPropagation();
        if (saving) return;
        setSaving(true); setError('');
        try {
            const response = await acknowledgeJobImportant(job.cos_job_id, importantRevision(job));
            if (!response.ok) {
                if (response.status === 409) {
                    const latest = await getJobDetails(job.cos_job_id);
                    if (latest.ok) await updateRef.current?.(await latest.json());
                    throw new Error('Job changed. Review the latest change before acknowledging.');
                }
                throw new Error('Unable to acknowledge Important. Please try again.');
            }
            await updateRef.current?.(await response.json());
        } catch (exception) { setError(exception.message); }
        finally { setSaving(false); }
    }
    return <span className="ms-2" onClick={event => event.stopPropagation()}>
        <button type="button" className="btn btn-sm btn-outline-danger" disabled={disabled || saving} onClick={acknowledge}>
            {saving ? 'Saving…' : 'Acknowledge'}
        </button>
        {error ? <span className="text-danger d-block" role="alert">{error}</span> : null}
    </span>;
}
